import { monitor_route_vehicleService } from '../_services';

const state = { onRequest: false, monitor_route_vehicle: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        monitor_route_vehicleService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  monitor_route_vehicle: state => {
    return state.monitor_route_vehicle
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.monitor_route_vehicle = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.monitor_route_vehicle = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.monitor_route_vehicle = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const monitor_route_vehicles = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
